import { CancelledError } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { getFaqQueryOptions } from '#widgets/faq/state/faq-query'

// import getCurrentUserRoleInfo from '#shared/lib/auth/get-current-user-role-info'

export const Route = createFileRoute('/client/_post-registration-required/info')({
  loader: async ({ context }) => {
    const { queryClient } = context

    try {
      await queryClient.ensureQueryData(getFaqQueryOptions('client'))
    } catch (error) {
      if (error instanceof CancelledError) return
      throw error
    }
  },
})
